export default __webpack_public_path__ + "10ff12411d01e055f8e063c881068a4b.png";